import React, { useEffect, useState, useRef } from "react";
import FloatingInput from "../../../components/input/FloatingInput";
// import CustomSelect from "../../../components/customselect/CustomSelect";
import ChipsInput from "../../../components/input/ChipsInput";
import { sendEmail } from "../../../pages/calculators/buyer/services/buyerNetService";

export default function EmailModal({ type, calc="", onClose, buyerFormData, showToaster, sellerFormData, isQuickMode, isQuickEstimate = false }) {

  const [email, setEmail] = useState([]);
  const [note, setNote] = useState('');
  const [imageSrc, setImageSrc] = useState(null);
  const [imageError, setImageError] = useState("");
  const [showAttachFiles, setShowAttachFiles] = useState(false);
  const [imageName, setImageName] = useState("");
  const fileInputRef = useRef(null);

  useEffect(() => {
    return () => {
      setEmail([]);
      setNote('');
      setShowAttachFiles(false);
      setImageSrc(null);
      setImageError('');
    }
  }, [])

  // Get subject from LS
  const subject = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const ucWords = (str = "") => str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    const fullName = ucWords(`${user.first_name ?? ""} ${user.last_name ?? ""}`).trim();
    const email = user.email || '';
    return `Closing Costs from ${fullName} at ${email}`;
  }

  // handle img upload 
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!['image/jpeg', 'image/png'].includes(file.type)) {
      setImageError('Only JPEG and PNG images are allowed.');
      setImageSrc(null);
      setImageName("");
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      setImageError('Image must be less than 10MB.');
      setImageSrc(null);
      setImageName("");
      return;
    }
    setImageError("");
    setImageName(file.name);
    const reader = new FileReader();
    reader.onloadend = () => {
      setImageSrc(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleEmailData = async (e) => {
    e.preventDefault();
    const payload = {
      emails: email,
      type,
      calc,
      isQuickMode,
      isQuickEstimate,
      optionType: isQuickEstimate ? "emailquickprint" : "emailprint",
      data: type === 'buyer' ? buyerFormData : sellerFormData,
      subject: subject(),
      note: note,
      attachments: [
        { "filename": imageName, "base64": imageSrc }
      ],
      mrsid: type === 'buyer' ? buyerFormData?.addressMeta?.mrsid : sellerFormData?.addressMeta?.mrsid,
    }
    
    const res = await sendEmail(payload);
    if (res?.status === 'success') {
      showToaster({ message: res.message, visible: true })
      onClose();
    }
  }

  return (
    <div className="modelspace pplication-fe model-select space-fields">
      <div className="frm-field-1 model-select-lbl">
        <div className="form-group">
          <label style={{ fontWeight: 500, marginBottom: 6, display: 'block' }}>Email Address</label>
          <ChipsInput value={email} onChange={data => setEmail(data)} inputType="email" />
        </div>
      </div>
      <div className="frm-field-1 model-select-lbl">
        <div className="form-group">
          <FloatingInput
            placeholder=""
            type="text"
            value={subject()}
            disabled
          />
          <label>Subject</label>
        </div>
      </div>
      <div className="frm-field-1 model-select-lbl">
        <div className="form-group">
          <textarea value={note} onChange={(e) => setNote(e.target.value)}></textarea>
          {/* <FloatingInput 
              type="text"
              value={note}
              onBlur={(e) => setNote(e.target.value)}
            /> */}
          <label>Note</label>
        </div>
      </div>

      <button style={{ height: '32px', color: "#043b7c", padding: "8px 0" }} onClick={() => setShowAttachFiles(!showAttachFiles)}>
        Attach Additional Files
      </button>

      {/* Image Upload Section */}
      {showAttachFiles && (
        <div style={{ border: '1px solid #e0e0e0', padding: 16, borderRadius: 4, marginBottom: 16 }}>
          <button
            type="button"
            style={{
              background: '#f5f5f5',
              border: 'none',
              padding: '5px 16px',
              borderRadius: 4,
              fontWeight: 500,
              cursor: 'pointer',
              fontSize: 14,
              color: '#222',
              height: 32,
              width: '50%'
            }}
            onClick={() => fileInputRef.current.click()}
          >
            Upload Image
          </button>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/jpeg,image/png"
            onChange={handleImageUpload}
            style={{ display: 'none' }}
          />
          {(imageError || imageSrc) && (<div style={{ marginTop: 16 }}>
            {imageError && (
              <p style={{ color: 'red', fontSize: 13, textAlign: 'center' }}>{imageError}</p>
            )}
            {imageSrc && (
              <div style={{ display: 'flex', justifyContent: 'center', maxHeight: "120px" }}>
                <img src={imageSrc} alt="Preview" style={{ maxWidth: '100%', maxHeight: 120, borderRadius: 6 }} />
              </div>
            )}
          </div>)}
        </div>
      )}

      <div className="frm-btn popup-2-btn">
        <button className="submit-btn btn-bg inpt-btn btn-discard" onClick={onClose}>Cancel</button>
        <button className="submit-btn btn-bg inpt-btn" onClick={handleEmailData} disabled={!email.length}>Send</button>
      </div>
    </div>
  );
}
